var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDryHorizontally = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7.57 7.57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#313332"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 7.57h7.57v-7.57h-7.57zm.62-6.95h6.38v6.38h-6.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.87 3.47h3.83v.62h-3.83z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDryHorizontally);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "DryHorizontally.b3207f715a85fd851e46837247b5d27f.svg";